
define(
	'C3.ShoppingExtensions.MeetTeam'
,   [
		'C3.ShoppingExtensions.MeetTeam.View'
	]
,   function (
		MeetTeamView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			const environment = container.getComponent("Environment");
			const layout = container.getComponent('Layout');
			const pageType = container.getComponent('PageType');
			
			if(layout && environment)
			{
				pageType.registerPageType({
			        name: 'meet-our-team',
		            routes: ['meet-our-team'],
		            view: MeetTeamView,
		            options : {
		            	application : layout.application,
		            	layout : layout
		            }
			    });
			}

		}
	};
});
